import * as React from "react";
import { getPrePacksPrefix, PrePacksLazyRenderContext } from "../helpers";
//Todo to be extract on lib - https://jira.dkcorpit.com/browse/SB-24657
export class PrePacksLazyRenderContainer extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.templateBaseClass = getPrePacksPrefix("lazyRenderContainer");
        this.compareChildren = (current, previous) => {
            const prevChildren = React.Children.toArray(previous.children);
            const nextChildren = React.Children.toArray(current.children);
            return prevChildren.some((child, index) => child["key"] !== nextChildren[index]["key"]);
        };
    }
    componentDidMount() {
        if (this.context.setHeight) {
            this.context.setHeight();
        }
    }
    getSnapshotBeforeUpdate(prevProps) {
        if (React.Children.count(this.props.children) !== React.Children.count(prevProps.children)) {
            return true;
        }
        if (this.compareChildren(this.props, prevProps)) {
            return true;
        }
        /**
         * A snapshot value (or null) should be returned,
         * https://reactjs.org/docs/react-component.html#getsnapshotbeforeupdate
         */
        // eslint-disable-next-line no-null/no-null
        return null;
    }
    componentDidUpdate(_prevProps, _prevState, snapshot) {
        if (snapshot && this.context.setHeight) {
            this.context.setHeight();
        }
    }
    render() {
        return (React.createElement("div", { ref: this.props.forwardedRef, className: this.templateBaseClass, "data-testid": this.templateBaseClass }, this.props.children));
    }
}
PrePacksLazyRenderContainer.contextType = PrePacksLazyRenderContext;
export const PrePacksLazyRenderContainerWithRef = React.forwardRef(({ children }, ref) => React.createElement(PrePacksLazyRenderContainer, { forwardedRef: ref }, children));
//# sourceMappingURL=PrePacksLazyRenderContainer.js.map